import { ErrorMessage } from '@/messages/error';
import { showUntranslatedToast } from '@/utils/toast';
import { AxiosError } from 'axios';

/**
 * Shows a toast and log error
 * @param message UI-friendly msg
 * @param error Message to log
 */
function showErrorToastAndLog(message: string, error?: any): void {
    showUntranslatedToast('error', message);

    if (error) {
        console.error(error);
    }
}

/**
 * Show a toast, log error, throws a new Error
 * @param message UI-friendly msg
 * @param error Error message to log
 * @throws new Error
 */
export function processErrorWithFeedback(message: string, error?: any): never {
    showErrorToastAndLog(message, error);
    throw new Error(message);
}

/**
 *
 * @param message UI-friendly msg
 * @param returnValue the value this function should return
 * @param error Error mesage to log
 * @returns The value of the `returnValue` parameter
 */
export function processErrorWithReturn(message: string, returnValue: any = null, error?: unknown): any {
    if (error instanceof AxiosError && error.response?.status === 403) return;

    showErrorToastAndLog(message, error);
    return returnValue;
}

/** Handles a given error. Uses the server message for the given status codes if the error is an AxiosError, otherwise uses the fallback message */
export function handleAxiosError(error: unknown, useServerMsgStatusCodes = [400], fallbackMessage: string = ErrorMessage.ERROR_OTHER) {
    const errorMessage =
        error instanceof AxiosError && useServerMsgStatusCodes.includes(error.status ?? 0) ? error.response?.data.message : fallbackMessage;

    // TODO: Change to processErrorWithFeedback to prevent continuing the script after an error occurs.
    return processErrorWithReturn(errorMessage);
}
